function getScrollbarWidth() {
    var scrollbox = document.createElement('div');
    scrollbox.style.overflow = 'scroll';
    document.body.appendChild(scrollbox);
    var width = scrollbox.offsetWidth - scrollbox.clientWidth;
    document.body.removeChild(scrollbox);
    return width;
}

(function () {
    $(window).setBreakpoints({ breakpoints: [ 768, 992 ] });
    $(window)
        .bind('breakpoint.enter.768', function () {
            app.plugin.trigger(app.plugin.BREAKPOINT_ENTER, { breakpoint: 768 });
        })
        .bind('breakpoint.leave.768', function () {
            app.plugin.trigger(app.plugin.BREAKPOINT_LEAVE, { breakpoint: 768 });
        })
        .bind('breakpoint.enter.992', function () {
            app.plugin.trigger(app.plugin.BREAKPOINT_ENTER, { breakpoint: 992 });
        })
        .bind('breakpoint.leave.992', function () {
            app.plugin.trigger(app.plugin.BREAKPOINT_LEAVE, { breakpoint: 992 });
        });
})();

(function () {
    var handleResize = function () {
        if (window.innerWidth >= 992) {
            $(document.body).attr('data-leftbar-compact-mode', 'fixed');
            $('.leftside-menu').attr('condensed', 'false');
        } else {
            $(document.body).attr('data-leftbar-compact-mode', 'condensed');
            $('.leftside-menu').attr('condensed', 'true');
        }
    }
    handleResize();
    var t;
    window.addEventListener('resize', function () {
        t && window.cancelAnimationFrame(t);
        t = window.requestAnimationFrame(function () {
            handleResize();
        });
    }, false);
})();

$(function () {
    document.documentElement.style.setProperty('--scrollbar-width', getScrollbarWidth() + 'px');

    $('.open-left').click(function () {
        var $body = $(document.body);

        $body.toggleClass('sidebar-enable')

        if (window.innerWidth >= 768) {
            $(document.body).attr('data-leftbar-compact-mode', function (_, value) {
                return value === 'fixed' ? 'condensed' : 'fixed';
            });
            $('.leftside-menu').attr('condensed', function (_, value) {
                return value === 'true' ? 'false' : 'true';
            });
        } else {
            $(document.body).attr('data-leftbar-compact-mode', 'condensed');
            $('.leftside-menu').attr('condensed', 'true');
        }
    });
});

app.modal.on('*', app.modal.LOADED, function () {
    $('.grid-ajax').each(function () {
        if ($(this).attr('data-name')) {
            app.grid.trigger($(this).attr('data-name'), app.grid.INIT);
        }
    });
    // app.plugin.trigger(app.plugin.BS_SELECT_INIT);
});

$(document).ajaxComplete(function () {
    app.plugin.trigger(app.plugin.AUTOSIZE_INIT);
    app.plugin.trigger(app.plugin.BS_BUTTON_CHECKBOX_INIT);
    app.plugin.trigger(app.plugin.BS_FILESTYLE_INIT);
    app.plugin.trigger(app.plugin.BS_SWITCH_INIT);
    app.plugin.trigger(app.plugin.BS_TOOLTIP_INIT);
    app.plugin.trigger(app.plugin.SELECT2_INIT);
}).ajaxError(function (event, jqXHR) {
    if ('responseJSON' in jqXHR && jqXHR['responseJSON']['notify']) {
        app.plugin.trigger(app.plugin.NOTY_SHOW, {
            type: 'error',
            text: jqXHR['responseJSON']['notify']
        });
    } else {
        if (jqXHR.statusText !== 'abort') {
            app.plugin.trigger(app.plugin.NOTY_SHOW, {
                type: 'error',
                text: 'An unexpected error has occurred.'
            });
        }
    }
}).ajaxSuccess(function (event, jqXHR) {
    if ('responseJSON' in jqXHR && jqXHR['responseJSON']['notify']) {
        app.plugin.trigger(app.plugin.NOTY_SHOW, {
            type: 'success',
            text: jqXHR['responseJSON']['notify']
        });
    }
});

$(document).on('submit', '.form-ajax', function () {
    app.form.trigger(this, app.form.SUBMIT);
    return false;
});

$(function () {
    $('.grid-ajax').each(function () {
        if ($(this).attr('data-name')) {
            app.grid.trigger($(this).attr('data-name'), app.grid.INIT);
        }
    });
    app.plugin.trigger(app.plugin.AUTOSIZE_INIT);
    app.plugin.trigger(app.plugin.BS_BUTTON_CHECKBOX_INIT);
    app.plugin.trigger(app.plugin.BS_DATERANGEPICKER_INIT, {
        e: $('.filter-daterange input').on(app.plugin.BS_DATERANGEPICKER_CHANGE, function () {
            $(this).closest('form').submit();
            $(this).trigger('change.yiiGridView');
            if ($(this).val() === '') {
                $(this).closest('.filter').addClass('filter-empty');
            } else {
                $(this).closest('.filter').removeClass('filter-empty');
            }
        })
    });
    app.plugin.trigger(app.plugin.BS_FILESTYLE_INIT);
    app.plugin.trigger(app.plugin.BS_POPOVER_INIT);
    app.plugin.trigger(app.plugin.BS_SWITCH_INIT);
    app.plugin.trigger(app.plugin.BS_TAB_INIT);
    app.plugin.trigger(app.plugin.BS_TOOLTIP_INIT);
    app.plugin.trigger(app.plugin.SELECT2_INIT);
    app.plugin.trigger(app.plugin.TEXTCOMPLETE_INIT);
    app.plugin.trigger(app.plugin.TYPEAHEAD_JS_INIT);

    $('body').on('change', '.bs-filestyle', function () {
        var $file = $(this);
        var $text = $(this).next().find('input');
        var $hidden = $(this).prev();
        var $widget = $(this).next();
        $widget.addClass('progress').removeClass('uploaded');
        var xhr = new XMLHttpRequest();
        xhr.upload.onprogress = function (event) {
            if (event['lengthComputable']) {
                var pct = parseInt(event['loaded'] / event['total'] * 100, 10);
                $text.attr('style', 'background-size: ' + pct + '% 100% !important').val(pct + '%');
            }
        };
        xhr.onload = function () {
            $text.attr('style', 'background-size: 0 100% !important');
            $widget.removeClass('progress');
            if (xhr['status'] === 200) {
                var data = JSON.parse(xhr['response']);
                $text.attr('placeholder', data['filename']);
                $text.val(data['filename']);
                $hidden.val(data['id']);
                $widget.addClass('uploaded');
                app.plugin.trigger(app.plugin.BS_FILESTYLE_UPLOADED, {
                    name: $hidden.attr('name'),
                    file: {
                        id: data['id']
                    }
                });
            } else {
                $text.val('');
                $hidden.val('');
                app.plugin.trigger(app.plugin.NOTY_SHOW, {
                    type: 'error',
                    text: JSON.parse(xhr['response'])
                });
            }
        };
        xhr.open('POST', window['base_url'] + '/uploads', true);
        xhr.send(function () {
            var data = new FormData();
            data.append('file', $file[0].files[0]);

            return data;
        }());
    });
});

// deprecated
$(function () {
    if ($('body').hasClass('role-publisher')) {
        $.getJSON({
            method: 'get',
            url: window['base_url'] + '/digests?dod=1&p=' + encodeURIComponent(new URL(window.location.href).pathname),
        }).then(function (data) {
            $('#drawer_digest_content').html(data.contents);
            if (!data['is_empty'] && data['notify_daily'] && !data['seen_today']) {
                var $modal = $('#modal_digest');
                $modal.find('.modal-body').html(data.contents);
                $modal[0].addEventListener('shown.bs.modal', function () {
                    $.ajax({
                        method: 'post',
                        url: window['base_url'] + '/digests/settings',
                        data: { _method: 'patch', key: 'last_seen_at' }
                    }).then(function () {
                        $('#btn_digest').removeClass('has-unread');
                    });
                });
                new bootstrap.Modal($modal[0]).show();
            }
            if (!data['seen_today']) {
                $('#btn_digest').addClass('has-unread');
            }
            $(':checkbox[name=digest_notify_daily]')
                .prop('checked', data['notify_daily']);
        });
        $(document).on('change', ':checkbox[name=digest_notify_daily]', function () {
            $.ajax({
                method: 'post',
                url: window['base_url'] + '/digests/settings',
                data: { _method: 'patch', key: 'notify_daily', value: $(this).is(':checked') ? '1' : '0' }
            });
        });
    }
});
